import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentListAction from './equipmentList.action.json' with { type: 'json' }
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import { equipmentObject } from '../equipmentObject'

export const equipmentExpression = expression(equipmentObject.shape)

const equipmentListDefinition = defineAction({
  ...equipmentListAction,

  input: z.object({
    filter: equipmentExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      title: 'Título',
      type: 'Tipo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeInactivated: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(equipmentObject),
    count: z.number(),
  }),
})

export default equipmentListDefinition
